module.exports = __webpack_public_path__ + "img/rl-hub-300w.6731a140.jpg";